
export class UnitDateTimeRequest {
    unitId: string;
    date: string;
    username: string;
}
